import { STATES } from '@afterpaytouch/core'
import { GetBlackListedStateErrorArgs, GetStateFullFromFormDataArgs } from './types'
import { ErrorCode } from '@afterpaytouch/portal-api'

export const canSubmit = ({ formValidation, formData }): boolean => {
  const hasNoErrors = Object.values(formValidation.errors).every((err) => !err)
  const hasAllFieldsTouched = Object.values(formValidation.touched).length >= Object.values(formData).length
  const hasAllValidFieldsTouchedTrue = Object.values(formValidation.touched).every((t) => t)

  return hasNoErrors && hasAllFieldsTouched && hasAllValidFieldsTouchedTrue
}

export const getStateFullFromFormData = ({ countryCode, state = '' }: GetStateFullFromFormDataArgs, defaultState?: string): string => {
  const stateFullMap = STATES[countryCode]?.fullname ?? {}
  const stateFull = stateFullMap[state]
  const stateFullDefault = defaultState ?? ''
  return stateFull ?? stateFullDefault
}

export const getBlackListedStateError = ({ formData, t }: GetBlackListedStateErrorArgs): string => {
  const stateFull = getStateFullFromFormData(formData, t('signUp:error.blacklistedStateDefaultState'))
  return t('signUp:error.blacklistedState', { stateFull })
}

export const handleAccountDetailsErrors = (error: { errorCode?: string }, softIdVerificationErrorHandling: (e: string) => Promise<void>): void => {
  if (error && typeof error === 'object') {
    const { errorCode } = error
    if (errorCode) {
      const isMaxAttemptsReachedForTypeError: boolean = errorCode === ErrorCode.MaxAttemptsReachedForType
      const isHighNationalityError: boolean = errorCode === ErrorCode.HighRiskNationality

      if (isMaxAttemptsReachedForTypeError || isHighNationalityError) {
        softIdVerificationErrorHandling(errorCode)
      }
    }
  }
}
